import { validateString } from "@deliverr/ui-facility";

const validGaylord = /^SG[A-Z0-9]{9}$/;
const validDockDoor = /^DD[A-Z0-9]{9}$/;
const validShipwellBolId = /^SW\d{7}$/;

export const isGaylord = validateString(validGaylord);
export const isDockDoor = validateString(validDockDoor);
export const isValidShipwellBolId = validateString(validShipwellBolId);
